
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Divider, Icon, Typography, Select, Input, message, Spin, DatePicker, Button, Tag } from 'antd';
import { getCookie } from '../../../../hook';
import moment from 'moment';
import $ from 'jquery';

// Actions
import { 
    upload_files, 
    get_leave_by_id,
    get_leave_type } from './../actions/leave.action';

const { Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;
const dateFormat = 'YYYY/MM/DD';

class RequestLeavesEdit extends Component {

    constructor( props ){
        super( props );

        this.state = {
            visible         : false,
            user_id         : 'none',
            leave_type_id   : 'none',
            from_date       : 'none',
            to_date         : 'none',
            reason          : 'none',
            company_id      : '',
            attachment      : '',
            unit            : 1,
            loader          : false,
            leave_type      : [],
        }

        this.handleAttachment   = this.handleAttachment.bind( this );
        this.handleBack         = this.handleBack.bind( this );
        this.handleSave         = this.handleSave.bind( this );
        this.handleDate         = this.handleDate.bind( this );

    }

    handleSave(){

        console.log( this.state )

        // if( this.state.user_id === "" || this.state.user_id === "none" &&
        //     this.state.leave_type_id === "" || this.state.leave_type_id === "none" &&
        //     this.state.from_date === "" || this.state.from_date === "none" &&
        //     this.state.to_date === "" || this.state.to_date === "none" ){
            
        //     message.error( "All fields are mandatory!" );
            
        //     return false;

        // }

        // this.props.request_leave( this.state );

    }

    handleBack(){
        this.props.history.goBack();
    }

    handleAttachment( e ){
        var fdata = new FormData();
        let user = getCookie('dv_hrms_user').split(',');
        var user_id =  user[1];

        this.setState({ loader: true });

        if( e.target.files.length>0 ){
            $.each( e.target.files, function( i, file ){

                if( file.size >= 524288000 ){
                    message.error( "File Size too Big", "error" );
                    return false;
                }
                
                fdata.append( "file"+[i], file );
                fdata.append( "user_id", user_id );

            });
        }

        this.props.upload_files( fdata );
    }

    componentWillMount(){

        this.props.get_leave_type();
        this.props.get_leave_by_id( this.props.match.params.id );

        let user = getCookie('dv_hrms_user').split(',');

        this.setState({
            employee: user[4],
            user_id: user[1],
            company_id: user[5]
        });
        
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.leave.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }

        if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "Successfully Listed Leave Type" ) {
            
            this.setState({
                leave_type: nextProps.leave.OUTPUT.DATA,
                loader: false
            });
        }

        if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "Successfully Listed Leaves Edit" ) {

            this.setState({ 
                leave_id        : nextProps.leave.OUTPUT.DATA.leave_id,
                leave_type_id   : nextProps.leave.OUTPUT.DATA.leave_type_id,
                from_date       : nextProps.leave.OUTPUT.DATA.from_date,
                to_date         : nextProps.leave.OUTPUT.DATA.to_date,
                reason          : nextProps.leave.OUTPUT.DATA.reason,
                company_id      : nextProps.leave.OUTPUT.DATA.company_id,
                attachment      : nextProps.leave.OUTPUT.DATA.attachment,
                unit            : Math.abs( nextProps.leave.OUTPUT.DATA.unit ),
                loader          : false,
            });

        }

        if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "File Uploaded" ) {
            this.setState({
                attachment: nextProps.leave.OUTPUT.DATA,
                loader: false
            });
        }

        if( nextProps.leave.STATUS.CODE === "400" ){
            if( nextProps.leave.STATUS.MESSAGE !== 'Error: 0 results' ){
                message.error( nextProps.leave.STATUS.MESSAGE );
                this.setState({ loader: false });
            }
        }

    }

    handleDate( date, dateString ){
        let isArr = Array.isArray( dateString )
        if( isArr === true ){
            this.setState({ from_date: dateString[0], to_date: dateString[1] })
        } else {
            this.setState({ from_date: dateString, to_date: dateString })
        }
    }
    
    render() {

        const list_leave_type = this.state.leave_type.map( ( item, i ) => 
            <Option key={ item.leave_type_id }>{ item.leave_type_name }</Option> )

        return (
            <div className="mod_leave_wrapper">
                <Spin spinning={this.state.loader}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <h2>
                                <Icon type="solution" />
                                &nbsp; Edit Leave
                            </h2>
                        </Col>
                        <Col span={12}>    
                            {/* Empty */}
                        </Col>
                    </Row>

                    <Divider />

                    <Row>
                        <Col offset={6} span={12}>

                            <Row gutter={16} className="mrg_b_10">
                                <Col span={12}>
                                    <label>Unit</label>
                                    <Select
                                        value={ this.state.unit }
                                        onChange={ (value)=>this.setState({ unit: value }) }
                                        style={{ width: '100%' }}>
                                        <Option value={ 1 }>Full Day</Option>
                                        <Option value={ 0.5 }>Half Day</Option>
                                    </Select>
                                </Col>
                                <Col span={12}>
                                    <label>Leave Type</label>
                                    <Select 
                                        onChange={ (value)=>this.setState({ leave_type_id: value }) }
                                        value={ this.state.leave_type_id }
                                        placeholder="Select Leave Type"
                                        style={{ width: '100%' }}>
                                        { list_leave_type }
                                    </Select>
                                </Col>
                            </Row>

                            <Row className="mrg_b_10">
                                <Col span={24}>
                                    <label>From - To Date</label>
                                    { ( this.state.unit === 1 ) ? 
                                        <RangePicker
                                            value={[moment( this.state.from_date, dateFormat ), moment( this.state.to_date, dateFormat )]}
                                            onChange={ this.handleDate } style={{ width: '100%' }} /> : 
                                        <DatePicker 
                                            value={ moment( this.state.from_date, dateFormat)}
                                            onChange={ this.handleDate } style={{ width: '100%' }} /> }
                                </Col>
                            </Row>

                            <Row className="mrg_b_10">
                                <Col span={ 24 }>
                                    <label>Reason for leave</label>
                                    <TextArea 
                                        value={ this.state.reason }
                                        onChange={ ( e ) => this.setState({ reason: e.target.value }) } row={3} />
                                </Col>
                            </Row>

                            <Row className="mrg_b_10">
                                <Col span={ 24 }>
                                    <label>Attachment ( <em styel={{ fontSize: '8px', color: '#999' }}>If you have multiple files please zip and attach</em> )</label>
                                    <Spin spinning={ this.state.loader }>
                                        <input type="file" className={ ( this.state.attachment ) ? 'success': '' } onChange={ this.handleAttachment } />
                                    </Spin>
                                    <div style={{ height: '7px' }}>&nbsp;</div>
                                    {
                                        ( this.state.attachment !== '' ) ? <a target="_blank" href={ this.state.attachment }>
                                            <Tag color="#87d068" className="fl_right" style={{margin: 0, cursor: 'pointer'}}>
                                                <Icon type="download" /> &nbsp;Download Attachment</Tag>
                                        </a> : ''   
                                    }
                                </Col>
                            </Row>

                            <Divider />
                            
                            <Row>
                                <Col span={ 24 }>
                                    <Button 
                                        onClick={ this.handleBack }
                                        icon={ "arrow-left" }>Cancel</Button>
                                    <Button 
                                        onClick={ this.handleSave }
                                        className="fl_right" type="primary">&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;</Button>  
                                </Col>
                            </Row>


                        </Col>
                    </Row>
                </Spin>
            </div>
        );
    }
}

function mapStatetoProps( state ){
    return {
        leave: state.leave
    }
}

export default connect( mapStatetoProps, { 
    upload_files, get_leave_by_id, get_leave_type })( RequestLeavesEdit );


// WEBPACK FOOTER //
// ./src/pages/requests/leave/edit/index.js